// extracted by mini-css-extract-plugin
export default {"borderedContainer":"ReorderSnapshot-module__borderedContainer--gEFMg","embedContainer":"ReorderSnapshot-module__embedContainer--B9QT0"};